export const API_URL_CONSTANT = Object.freeze({
  authentication: {
    logIn: 'partner/adminLogin',
    verifyLoginOTP: 'partner/adminVerifyCode',
    forgotPassword: 'partner/adminforgotPassword',
    verifyForgotPasswordOTP: 'partner/adminforgotPassword/verifyCode',
    resetPassword: 'partner/adminforgotPassword/newPassword',
    getUserPermissions: 'partner/getAdminUserPermissions',
  },
  profile: {
    changePassword: 'partner/adminResetPassword',
  },
  partner: {
    getPartnerList: 'admin/listPartners',
    getPartnerDetails: 'partner/get',
    addPartner: 'admin/registerPartner',
    updatePartner: 'partner/update',
    updatePartnerStatus: 'admin/updatePartnerStatus',
    deletePartner: 'admin/deletePartner',
  },
  wallet: {
    getPartnerWalletList: 'partner/listWallet',
    addPartnerWallet: 'partner/createWallet',
    getSenderWalletList: 'partner/listSenderWallet',
    addSenderWallet: 'partner/createSenderWallet',
  },
  transaction: {
    getTransactionList: 'partner/listSenderTransactions',
    getTransactionDetails: 'partner/getSenderTransaction',
    updateTransactionStatus: 'partner/confirmSenderTransaction',
    updatePayoutStatus: 'partner/updatePayoutStatus',
    getTransactionCharges: 'partner/getCharges',
    createTransaction: 'partner/createSenderTransaction',
  },
  sender: {
    getSenderList: 'partner/listSenders',
    getSenderDetails: 'partner/getSender',
    addSender: 'partner/addSender',
    updateSender: 'partner/updateSender',
    updateSenderActiveStatus: 'partner/updateSenderActiveStatus',
    updateSenderKycAmlStatus: 'partner/updateSenderKycAmlStatus',
    updateSenderPassword: 'partner/updateSenderPassword',
    updateSenderPIN: 'partner/updateSenderPIN',
  },
  reports: {
    senderReport: 'partner/senderReport',
    beneficiaryReport: 'partner/beneficiaryReport',
  },
  recipient: {
    getRecipientList: 'partner/listBeneficiaries',
    getRecipientDetails: 'partner/getBeneficiary',
    addRecipient: 'partner/addBeneficiary',
    updateRecipient: 'partner/updateBeneficiary',
    deleteRecipient: 'partner/deleteBeneficiary',
  },
  user: {
    getUserList: 'partner/listAdminUsers',
    getUserDetails: 'partner/getAdminUser',
    getPartnerRole: 'partner/listRoles',
    addUser: 'partner/addAdminUsers',
    updateUser: 'partner/updateAdminUsers',
    deleteUser: 'partner/deleteAdminUsers',
  },
  role: {
    getRoleList: 'admin/listRoles',
    getRoleDetails: 'admin/getRole',
    addRole: 'admin/addRole',
    updateRole: 'admin/updateRole',
    deleteRole: 'admin/deleteRole',
  },
  permission: {
    getPermissionList: 'admin/listPermissions',
    getPermissionDetails: 'admin/getPermission',
    addPermission: 'admin/addPermission',
    updatePermission: 'admin/updatePermission',
    deletePermission: 'admin/deletePermission',
  },
  countrySettings: {
    addSourceCountry: 'partner/addSourceCountries',
    updateSourceCountry: 'partner/updateSourceCountries',
    deleteSourceCountry: 'partner/deleteSourceCountries',
    addDestinationCountry: 'partner/addDestinationCountries',
    updateDestinationCountry: 'partner/updateDestinationCountries',
    deleteDestinationCountry: 'partner/deleteDestinationCountries',
    getConversionRate: 'partner/listCharges',
    addConversionRate: 'partner/addCharges',
    updateConversionRate: 'partner/updateCharges',
    deleteConversionRate: 'partner/deleteCharges',
  },
  masterTransactionSettings: {
    listSourceOfIncomes: 'master/listSourceOfIncomes',
    addSourceOfIncome: 'master/addSourceOfIncome',
    updateSourceOfIncome: 'master/updateSourceOfIncome',
    deleteSourceOfIncome: 'master/deleteSourceOfIncome',
    listPurposes: 'master/listRemittancePurposes',
    addPurpose: 'master/addRemittancePurpose',
    updatePurpose: 'master/updateRemittancePurpose',
    deletePurpose: 'master/deleteRemittancePurpose',
    listTransferTypes: 'master/listPayinTransferTypes',
    addTransferType: 'master/addPayinTransferType',
    updateTransferType: 'master/updatePayinTransferType',
    deleteTransferType: 'master/deletePayinTransferType',
    listServiceLevels: 'master/listServiceLevels',
    addServiceLevel: 'master/addServiceLevel',
    updateServiceLevel: 'master/updateServiceLevel',
    deleteServiceLevel: 'master/deleteServiceLevel',
    listPaymentMethods: 'master/listPayinPaymentMethods',
    addPaymentMethod: 'master/addPayinPaymentMethod',
    updatePaymentMethod: 'master/updatePayinPaymentMethod',
    deletePaymentMethod: 'master/deletePayinPaymentMethod',
  },
  masterPartnerTransactionSettings: {
    getMasterTransactionSettings: 'master/listTransactionSettings',
    getTransactionSettings: 'master/listPartnerTransactionSettings',
    addTransactionSetting: 'master/addPartnerTransactionSettings',
    updateTransactionSetting: 'master/updatePartnerTransactionSettings',
    deleteTransactionSetting: 'master/deletePartnerTransactionSettings',
  },
  partnerTransactionSettings: {
    getTransactionSettings: 'partner/listTransactionSettings',
    addTransactionSetting: 'partner/addTransactionSettings',
    updateTransactionSetting: 'partner/updateTransactionSettings',
    deleteTransactionSetting: 'partner/deleteTransactionSettings',
  },
  masterAdapterSettings: {
    listAdapters: 'master/listAdapters',
    addAdapter: 'master/addAdapter',
    updateAdapter: 'master/updateAdapter',
    deleteAdapter: 'master/deleteAdapter',
  },
  masterPartnerAdapterSettings: {
    listAdapters: 'master/listPartnerAdapterSettings',
    addAdapter: 'master/addPartnerAdapterSettings',
    updateAdapter: 'master/updatePartnerAdapterSettings',
    deleteAdapter: 'master/deletePartnerAdapterSettings',
  },
  velocityLimit: {
    getVelocityLimitList: 'partner/listVelocity',
    getVelocityLimitDetails: 'partner/getVelocity',
    addVelocityLimit: 'partner/addVelocity',
    updateVelocityLimit: 'partner/updateVelocity',
    deleteVelocityLimit: 'partner/deleteVelocity',
  },
  common: {
    getCountryList: 'master/listCountries',
    getSourceCountryList: 'partner/listSourceCountries',
    getDestinationCountryList: 'partner/listDestinationCountries',
    // Uploaded documents live in a private GCS bucket, so their stored links
    // 403 when opened directly. This exchanges one for a viewable image.
    getGcsImage: 'partner/getGcsImage',
  },
  accountDeletion: {
    requestCode: 'sender/accountDeletion/requestCode',
    confirm: 'sender/accountDeletion/confirm',
  },
  // Delivery / collection-point / mobile-operator lookups used to populate the
  // conditional transfer-detail groups on the recipient & transaction forms.
  delivery: {
    getMobileNetworkOperators: 'transaction/getMobileNetworkOperators',
    getDeliveryBanks: 'transaction/getDeliveryBanks',
    getDeliveryBranchStates: 'transaction/getDeliveryBranchStates',
    getDeliveryBranchCities: 'transaction/getDeliveryBranchCities',
    getDeliveryBranches: 'transaction/getDeliveryBranches',
    getCollectionPointStates: 'transaction/getCollectionPointStates',
    getCollectionPointCities: 'transaction/getCollectionPointCities',
    getCollectionPoints: 'transaction/getCollectionPoints',
    checkVelocityLimit: 'transaction/checkVelocityLimit',
    getRates: 'transaction/getRates',
  },
} as const);
